export const TurvoShipment = 0;
export const TurvoCustomerOrder = 1;
export const TurvoItem = 2;
export const OrderGroup = 3;